package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Divider
import androidx.compose.material.Icon
import androidx.compose.material.OutlinedButton
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextAlign
import com.hyperether.goodjob.models.JobFilter
import com.hyperether.goodjob.models.UserTeam
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.assignees
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.clear_all
import com.hyperether.goodjob.resources.confirm
import com.hyperether.goodjob.resources.filter
import com.hyperether.goodjob.resources.job_status_cancelled
import com.hyperether.goodjob.resources.job_status_completed
import com.hyperether.goodjob.resources.job_status_draft
import com.hyperether.goodjob.resources.location
import com.hyperether.goodjob.resources.schedule
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.scenes.components.FilterSectionMobile
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.toggleSelection
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun FilterJobsDialog(
    filterMap: Map<List<String>, Set<String>>,
    onDismiss: () -> Unit,
    onApply: (map: Map<JobFilter, Set<String>>) -> Unit,
    isMobileView: Boolean,
    isSchedulerFilter: Boolean = false,
    isEmployee: Boolean,
    userTeams: List<UserTeam?>?
) {
    val status: List<String> =
        filterMap.keys.elementAtOrNull(JobFilter.STATUS.value) ?: emptyList()
    val activeStatusSet = filterMap.keys.elementAtOrNull(JobFilter.STATUS.value)?.toMutableSet()
    activeStatusSet?.removeAll(
        setOf(
            stringResource(Res.string.job_status_completed),
            stringResource(Res.string.job_status_cancelled),
            stringResource(Res.string.job_status_draft)
        )
    )

    val initialSelectedStatus: Set<String> = if (FilterDialogStateManager.isFirstOpen) {
        if (activeStatusSet?.isEmpty() == true) {
            status.toSet()
        } else {
            activeStatusSet ?: emptySet()
        }
    } else {
        filterMap.values
            .elementAtOrNull(JobFilter.STATUS.value)
            ?.takeIf { it.isNotEmpty() }
            ?: emptySet()
    }

    val employees: List<String> =
        filterMap.keys.elementAtOrNull(JobFilter.ASSIGNEE.value) ?: emptyList()
    val employeeTeams = employees.toSet().intersect(
        userTeams?.mapNotNull { it?.value }?.toSet().orEmpty()
    ).toList()
    val initialSelectedEmployees: Set<String> =
        filterMap.values.elementAtOrNull(JobFilter.ASSIGNEE.value) ?: emptySet()

    val locations: List<String> =
        filterMap.keys.elementAtOrNull(JobFilter.LOCATION.value) ?: emptyList()
    val initialSelectedLocations: Set<String> =
        filterMap.values.elementAtOrNull(JobFilter.LOCATION.value) ?: emptySet()

    val schedule: List<String> =
        filterMap.keys.elementAtOrNull(JobFilter.SCHEDULE.value) ?: emptyList()
    val initialSelectedSchedule: Set<String> =
        filterMap.values.elementAtOrNull(JobFilter.SCHEDULE.value) ?: emptySet()


    // Initialize state with the current selections
    var selectedStatus by remember { mutableStateOf(initialSelectedStatus) }
    var selectedEmployees by remember { mutableStateOf(initialSelectedEmployees) }
    var selectedLocations by remember { mutableStateOf(initialSelectedLocations) }
    var selectedSchedule by remember { mutableStateOf(initialSelectedSchedule) }

    if (isMobileView) {
        Box(modifier = Modifier.fillMaxSize()) {

            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .clickable(
                        onClick = {},
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() })
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .align(Alignment.Center)
                        .background(Color.White)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            painter = painterResource(Res.drawable.back_arrow),
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .weight(1f)
                                .offset(x = -30.toScaleDp())
                                .align(Alignment.CenterVertically)
                                .clickable {
                                    onDismiss()
                                }
                        )

                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = 20.toScaleSp(),
                                modifier = Modifier
                                    .weight(3f)
                                    .align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = 14.toScaleSp(),
                                color = BlueApp,
                                modifier = Modifier
                                    .weight(1f)
                                    .align(Alignment.CenterVertically)
                                    .clickable {
                                        selectedStatus = emptySet()
                                        selectedLocations = emptySet()
                                        selectedEmployees = emptySet()
                                        selectedSchedule = emptySet()
                                    }
                            )
                        }
                    }
                    Divider(
                        modifier = Modifier.height(2.toScaleDp())
                            .background(Color.LightGray.copy(alpha = 0.1f))
                    )

                    Column(
                        modifier = Modifier
                            .padding(start = 16.toScaleDp())
                            .weight(1f)
                            .verticalScroll(rememberScrollState())
                            .disableMouseDragScrollOnWeb()
                    ) {
                        if (status.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.status),
                                options = status,
                                selectedOptions = selectedStatus,
                                onOptionSelected = { option ->
                                    selectedStatus = toggleSelection(selectedStatus, option)
                                }
                            )
                        }

                        if (!isEmployee) {
                            if (employees.any { it.isNotBlank() }) {
                                Spacer(modifier = Modifier.height(10.toScaleDp()))

                                FilterSectionMobile(
                                    title = stringResource(Res.string.assignees),
                                    options = employees,
                                    selectedOptions = selectedEmployees,
                                    onOptionSelected = { option ->
                                        selectedEmployees =
                                            toggleSelection(selectedEmployees, option)
                                    }
                                )
                            }
                        } else {
                            if (employeeTeams.any { it.isNotBlank() }) {
                                Spacer(modifier = Modifier.height(10.toScaleDp()))

                                FilterSectionMobile(
                                    title = stringResource(Res.string.assignees),
                                    options = employeeTeams,
                                    selectedOptions = selectedEmployees,
                                    onOptionSelected = { option ->
                                        selectedEmployees =
                                            toggleSelection(selectedEmployees, option)
                                    }
                                )
                            }
                        }

                        if (locations.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.location),
                                options = locations,
                                selectedOptions = selectedLocations,
                                onOptionSelected = { option ->
                                    selectedLocations = toggleSelection(selectedLocations, option)
                                }
                            )
                        }

                        if (schedule.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.schedule),
                                options = schedule,
                                selectedOptions = selectedSchedule,
                                onOptionSelected = { option ->
                                    selectedSchedule = toggleSelection(selectedSchedule, option)
                                }
                            )
                        }
                    }
                    FilledButton(
                        onClick = {
                            // Pass selected options when applying filters
                            onApply(
                                mapOf(
                                    JobFilter.STATUS to selectedStatus,
                                    JobFilter.ASSIGNEE to selectedEmployees,
                                    JobFilter.LOCATION to selectedLocations,
                                    JobFilter.SCHEDULE to selectedSchedule
                                )
                            )
                            FilterDialogStateManager.markOpened()
                            onDismiss()
                        },
                        modifier = Modifier.padding(
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp(),
                            top = 30.toScaleDp(),
                            bottom = 20.toScaleDp()
                        ).fillMaxWidth(),
                        text = stringResource(Res.string.confirm),
                        isEnabled = true,
                    )
                }
            }
        }
    } else {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .clickable(
                    onClick = {},
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() }
                )
        ) {
            Box(
                modifier = Modifier
                    .width(370.toScaleDp())
                    .align(Alignment.Center)
                    .shadow(8.toScaleDp(), RoundedCornerShape(12.toScaleDp()))
                    .clip(RoundedCornerShape(12.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        .align(Alignment.Center)
                        .background(Color.White)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(8.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = 20.toScaleSp(),
                                modifier = Modifier.align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = 14.toScaleSp(),
                                color = BlueApp,
                                modifier = Modifier
                                    .padding(start = 15.toScaleDp())
                                    .align(Alignment.CenterVertically)
                                    .clickableWithPointer {
                                        selectedStatus = emptySet()
                                        selectedLocations = emptySet()
                                        selectedEmployees = emptySet()
                                        selectedSchedule = emptySet()
                                    }
                            )
                        }
                        Spacer(modifier = Modifier.weight(1f))

                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .clickableWithPointer {
                                    onDismiss()
                                }
                        )
                    }
                    val scrollState = rememberScrollState()
                    Column(
                        modifier = Modifier
                            .weight(1f)
                            .verticalScrollbar(scrollState)
                            .verticalScroll(scrollState)
                            .disableMouseDragScrollOnWeb()
                            .padding(horizontal = 8.toScaleDp())
                    ) {
                        if (status.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.status),
                                options = status,
                                selectedOptions = selectedStatus,
                                onOptionSelected = { option ->
                                    selectedStatus = toggleSelection(selectedStatus, option)
                                }
                            )
                        }

                        if (!isEmployee) {
                            if (employees.any { it.isNotBlank() }) {
                                Spacer(modifier = Modifier.height(10.toScaleDp()))

                                FilterSectionMobile(
                                    title = stringResource(Res.string.assignees),
                                    options = employees,
                                    selectedOptions = selectedEmployees,
                                    onOptionSelected = { option ->
                                        selectedEmployees =
                                            toggleSelection(selectedEmployees, option)
                                    }
                                )
                            }
                        } else {
                            if (employeeTeams.any { it.isNotBlank() }) {
                                Spacer(modifier = Modifier.height(10.toScaleDp()))

                                FilterSectionMobile(
                                    title = stringResource(Res.string.assignees),
                                    options = employeeTeams,
                                    selectedOptions = selectedEmployees,
                                    onOptionSelected = { option ->
                                        selectedEmployees =
                                            toggleSelection(selectedEmployees, option)
                                    }
                                )
                            }
                        }

                        if (locations.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.location),
                                options = locations,
                                selectedOptions = selectedLocations,
                                onOptionSelected = { option ->
                                    selectedLocations = toggleSelection(selectedLocations, option)
                                }
                            )
                        }

                        if (schedule.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.schedule),
                                options = schedule,
                                selectedOptions = selectedSchedule,
                                onOptionSelected = { option ->
                                    selectedSchedule = toggleSelection(selectedSchedule, option)
                                }
                            )
                        }
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 16.toScaleDp(), bottom = 20.toScaleDp()),
                        //horizontalArrangement = Arrangement.spacedBy(16.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {

                        OutlinedButton(
                            onClick = {
                                onDismiss()
                            },
                            modifier = Modifier
                                .weight(1f)
                                .height(50.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand),
                            border = BorderStroke(1.toScaleDp(), BlueApp),
                            shape = RoundedCornerShape(50),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White,
                                backgroundColor = Color.Transparent
                            )
                        ) {
                            DisableSelection {
                                Text(
                                    text = stringResource(Res.string.cancel),
                                    maxLines = 1,
                                    fontSize = 12.toScaleSp(),
                                    color = BlueApp,
                                )
                            }
                        }
                        Spacer(modifier = Modifier.width(10.toScaleDp()))
                        FilledButton(
                            onClick = {
                                onApply(
                                    mapOf(
                                        JobFilter.STATUS to selectedStatus,
                                        JobFilter.ASSIGNEE to selectedEmployees,
                                        JobFilter.LOCATION to selectedLocations,
                                        JobFilter.SCHEDULE to selectedSchedule
                                    )
                                )
                                FilterDialogStateManager.markOpened()
                                onDismiss()
                            },
                            text = stringResource(Res.string.confirm),
                            isEnabled = true,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}

